import { render } from "./WinOrLoss.vue?vue&type=template&id=dcc23458&scoped=true"
import script from "./WinOrLoss.vue?vue&type=script&lang=js"
export * from "./WinOrLoss.vue?vue&type=script&lang=js"

import "./WinOrLoss.vue?vue&type=style&index=0&id=dcc23458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc23458"]])

export default __exports__